import { Injectable } from '@angular/core';
import { Category } from '~app/modules/generic/models';

const SCALE_LABEL_CATEGAGORY_IDS: string[] = [
  '4c69bc7b-fc45-4020-afed-05386c2fabcc',
  '2f476ac1-abcb-43d1-9a8d-f511aff31f00',
  '2c22761e-89db-4395-b046-daa925309d82',
  '1f71b459-ba9e-4be0-b11a-9fabe6207c25'
];

@Injectable()
export class EnergyLabelScaleService {

  public shouldShowScaleEnergyLabel(productCategories: Category[]): boolean {
    return !!productCategories?.find((category: Category) =>
      SCALE_LABEL_CATEGAGORY_IDS?.includes(category?.id)
    );
  }
}
